import { type App, reactive } from 'vue'
import { useMediaJudgement } from '../hooks/useMediaJudgement'

export function loadMediaJudgement(app: App) {
  app.config.globalProperties.$mediaInfo = reactive(useMediaJudgement())
  return app
}

export default loadMediaJudgement
